<template>
  <div class="spinner-border text-secondary text-center" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</template>
<script>
export default {
  name: "Loader",
};
</script>